"use client";

import { QueryResponseInitial, useQuery } from "@sanity/react-loader";
import { SanityDocument } from "next-sanity";

import { impactPageQuery } from '@otomoro/sanity/lib/queries/pages/impactPage.groq'
import ImpactPage from "./ImpactPage";

export default function ImpactPagePreview({
  initial,
}: {
  initial: QueryResponseInitial<SanityDocument[]>;
}) {
	const { data } = useQuery<SanityDocument[] | null>(
    impactPageQuery,
    {},
    { initial }
  );

	return data ? (
    <ImpactPage data={data as any} />
  ) : (
    <div className="bg-red-100">No posts found</div>
  );
}
